import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { KeyInsightCard } from '@insided/deprecated-control/analytics/KeyInsightCard'
import { SegmentData } from './types'
import SegmentDescription from './SegmentDescription'
import percentageFormat from '@insided/control/utils/percentageFormat'

export interface SegmentDashboardProps {
  segmentData: SegmentData
  description: string
  totalMatchingUsers: number
  onDescriptionUpdated: (newValue: string) => void
}

class SegmentDashboard extends Component<SegmentDashboardProps> {
  render() {
    const { segmentData, description, totalMatchingUsers, onDescriptionUpdated } = this.props
    const matchingUsers = totalMatchingUsers !== 0 ? totalMatchingUsers : '-'
    const matchingPercentage = totalMatchingUsers !== 0
      ? percentageFormat(totalMatchingUsers / segmentData.total_users, { isRatio: true })
      : '-'

    return (
      <div className='segment-metrics-container'>
        <SegmentDescription
          title='Description'
          description={description}
          onDescriptionChanged={onDescriptionUpdated}
        />
        <KeyInsightCard
          title='Number of users'
          total={matchingUsers}
          titleTooltip='The number of users matching the criteria.'
          isLoading={false}
          hideComparisionWithPreviousPeriod
        />
        <KeyInsightCard
          title='Percentage of all users'
          total={matchingPercentage}
          titleTooltip='The percentage of users matching the criteria.'
          isPercentage
          hideComparisionWithPreviousPeriod
          isLoading={false}
        />
      </div>
    )
  }
}

export default SegmentDashboard
